import clsx from 'clsx'
import React, { ReactNode } from 'react'
import { BasicStyledComponent, DSCheckDetailsProduct } from 'shared-definitions/types'
import AppImage from './AppImage'
import Arrow from 'shared-svg/ArrowRightShadeSmall.svg'
import styles from './CheckDetailsProductCell.module.css'

interface CheckDetailsProductCellProps extends BasicStyledComponent {
  product: DSCheckDetailsProduct
  onSeeMore: (productId: string, signal?: AbortSignal) => void
  variant?: 'default' | 'compact'
  underImageSlot?: ReactNode
}

export const CheckDetailsProductCell: React.FC<CheckDetailsProductCellProps> = ({
  variant = 'default',
  className,
  product,
  onSeeMore,
  underImageSlot,
}) => {
  const onClick = (): void => {
    onSeeMore(product.id)
  }

  return (
    <div
      className={clsx(styles.container, className, {
        [styles.compact]: variant === 'compact',
        [styles.default]: variant === 'default',
        [styles.hasUnderImage]: underImageSlot !== undefined,
      })}
    >
      <button type="button" onClick={onClick} className={styles.buttonImage}>
        {product.badges.length > 0 && (
          <div className={styles.badges}>
            {product.badges.slice(0, 1).map((badge, index) => (
              <AppImage
                image={badge}
                sizes={80}
                layout="raw"
                key={index}
                imageClassName={styles.badgeImage}
                className={styles.badge}
              />
            ))}
          </div>
        )}
        {product.image && (
          <AppImage
            image={product.image}
            sizes={variant === 'default' ? 104 : 68}
            layout="raw"
            className={styles.image}
          />
        )}
      </button>
      {underImageSlot && <div className={styles.underImageSlot}>{underImageSlot}</div>}
      <button type="button" onClick={onClick} className={styles.content}>
        <h5 className={styles.title}>{product.title}</h5>
        {product.price && <div className={styles.price}>{product.price}</div>}
        <div className={styles.subTitle}>{product.subTitle}</div>
        {variant === 'default' && (
          <div className={styles.tags}>
            {product.tags.list.map((tag, index) => (
              <span key={index} className={styles.tag}>
                {tag}
              </span>
            ))}
            <span className={styles.tagPostfix}>{product.tags.postfix}</span>
          </div>
        )}
        <div className={styles.spacer} />
        <div className={styles.seeMore}>
          {product.seeMore}
          <Arrow className={styles.arrow} />
        </div>
      </button>
    </div>
  )
}
